<div class="timeline">
    <div class="timeline__hours">
        <span>00</span>
        <span>6</span>
        <span>12</span>
        <span>18</span>
        <span>24</span>
    </div>

    <div class="timeline__minutes">
        <div 
            *ngFor="let item of day_minutes"
            [attr.data-minute]="item"
            class="timeline__minutes__item"
        ></div>
    </div>

    <div
        *ngFor="let item of routesDisplayInTimeline"
        [ngStyle]="{ width: item.width + 'px', left: item.startPosition + 'px' }"
        pTooltip="{{ 'date' | translate }}: {{ item.startHour }} - {{ item.endHour || 'During' }}"
        tooltipPosition="top"
        class="timeline__route"
    ></div>

    <div
        *ngFor="let item of eventsDisplayInTimeline; trackBy: trackByEvent"
        [pTooltip]="tooltipEventBuilder(item)"
        tooltipPosition="top"
        [ngStyle]="{ 
            left: item.startPosition + 'px'
        }"
        [ngClass]="{
            'plus': item.eventAction === VALUE_SIGN.EventFuelRefuelling,
            'minus': item.eventAction === VALUE_SIGN.EventFuelLoss
        }"
        class="timeline__event"
    >
        <img class="timeline__event__icon-fuel" src="/assets/images/vehicles/fuel.svg" alt="">
    </div>
</div>
